package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class DiagnosisSettingSex(private val literal: String) : IEnumType {
	不限("不限"),
	男性("男性"),
	女性("女性");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "diagnosis_setting_sex"}
	override fun getLiteral(): String {return literal}
}
